import { cleanJSONString } from '../../utils/cleanJSONString';
import { DataModelDesignerActionTypes } from './constants';
import { findNewObjects, findNewUniqueObjects, renameDuplicate, uniqueNameForObject, uniqueNumberForObject } from '../../utils/renameDuplicate';

interface State {
    dataModelId: any | "",
    allFieldList: any[],
    fieldList: any[],
    newFieldList: any[],
    shaxesList: any[],   
    isChangeSelectedColumns: any,

    
    edgeList: any[]
}


const INIT_STATE = {
    dataModelId: "",
    allFieldList: [],
    fieldList: [],
    newFieldList: [],
    shaxesList: [],   
    isChangeSelectedColumns: false,

    
    
    edgeList: []
};

const DataModelDesign = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {
        case DataModelDesignerActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case DataModelDesignerActionTypes.CHANGE_SEARCH_VALUE:
            if (action.payload === '') {
                return { ...state, fieldList: state.allFieldList };
            }
            const searchItems = state.allFieldList.filter((item: any) => item.name.toLowerCase().includes(action.payload))
            return {
                ...state,
                fieldList: searchItems,
            };

        case DataModelDesignerActionTypes.CHANGE_FIELD:
            return {
                ...state,
                fieldList: action.payload,
                allFieldList: action.payload,
            };

        case DataModelDesignerActionTypes.CHANGE_COLUMN_ALIAS:           
            var s_tShaxesFieldalias = state.shaxesList;
            const dtsfa = s_tShaxesFieldalias.findIndex((x: any) => x.uniqueId === action.payload.id)         
            if (dtsfa !== -1) {    
                const s_IsInSelected = s_tShaxesFieldalias[dtsfa].selectedColumns.findIndex((x: any) => x.name === action.payload.name && x?.tableName===action.payload?.tableName)           
                if (s_IsInSelected !== -1) {
                    s_tShaxesFieldalias[dtsfa].selectedColumns[s_IsInSelected].alias=action.payload.alias
                }
                               
            }
            
            return {
                ...state,
                shaxesList: s_tShaxesFieldalias,
            };

        case DataModelDesignerActionTypes.CHANGE_SELECTED_FIELD:
            let s_isChangeSelectedColumns = state.isChangeSelectedColumns            
            var s_tShaxesField = state.shaxesList;

            const dtsf = s_tShaxesField.findIndex((x: any) => x.uniqueId === action.payload?.id)           
            if (dtsf !== -1) {
                let faray: any = [];

                action.payload?.selectedColumnForm?.map((s: any) => {
                    const s_IsInSelected = s_tShaxesField[dtsf].selectedColumns.findIndex((x: any) => x.name === s?.name && x?.tableName===s?.tableName)
                    let s_Alias = "";
                    if (s_IsInSelected !== -1) {
                        s_Alias = s_tShaxesField[dtsf].selectedColumns[s_IsInSelected].alias;
                        faray.push({ name: s.name, alias: s_Alias,radioItemId:s?.radioItemId,selectedListId:s?.selectedListId,formListId:s?.formListId,formNameList:s?.formNameList,fieldFormListId:s?.fieldFormListId,fieldFormNameList:s?.fieldFormNameList, tableName:s?.tableName,tableAlias:s?.tableAlias })
                    }
                    else

                        faray.push({ name: s.name, alias: s.labelAlias, radioItemId:s?.radioItemId,selectedListId:s?.selectedListId,formListId:s?.formListId,formNameList:s?.formNameList,fieldFormListId:s?.fieldFormListId,fieldFormNameList:s?.fieldFormNameList, tableName:s?.tableName,tableAlias:s?.tableAlias })
                })
                s_tShaxesField[dtsf].selectedColumns = faray;
            }

            return {
                ...state,
                shaxesList:s_tShaxesField,              
                isChangeSelectedColumns: !s_isChangeSelectedColumns
            };

        case DataModelDesignerActionTypes.CHANGE_SHAXES:          
            var tShaxes = state.shaxesList;

            if (action?.payload?.length > tShaxes?.length) {
                if (action.payload.length === tShaxes.length + 1) {
                    const addedTables = findNewUniqueObjects(tShaxes, action.payload)
                    if (addedTables) {
                        const addedTablesUniq = uniqueNumberForObject(addedTables[0], tShaxes)
                        const dts = action.payload.findIndex((x: any) => x.uniqueId === addedTablesUniq.uniqueId)
                        if (dts !== -1) {
                            action.payload[dts].uniqueNumber = addedTablesUniq.uniqueNumber
                            action.payload[dts].position = { x: (tShaxes.length * 100) + 10, y: (tShaxes.length * 50) + 10 }                           
                        }
                        tShaxes = action.payload
                    }
                }
                else {
                    tShaxes = action.payload
                }
            }
            else
                tShaxes = action.payload
                                              
            tShaxes?.map((s: any) => {
                let s_Columns: any = [];
                let s_Schema: any = [];
                if (s?.schema) {
                    let cleanedSchema = cleanJSONString(s?.schema);
                    s_Schema = cleanedSchema && JSON.parse(cleanedSchema);
                }
                
                s_Columns = s_Schema
                s.columns = s_Columns;
                let s_Position = s.position                                                        
            })

            return {
                ...state,
                shaxesList: tShaxes//action.payload,                                            
            };

        case DataModelDesignerActionTypes.CHANGE_SHAXES_REMOVE:
            var tShaxesRemove = state.shaxesList;
            var tEdgeList = state.edgeList;
          
                     
            let s_isChangeSelectedColumnsRemove = state.isChangeSelectedColumns

            if (action.payload) {
                tShaxesRemove = tShaxesRemove.filter((x: any) => x.uniqueId !== action.payload)
                tEdgeList=tEdgeList.filter(x=> x.source!==action.payload && x.target!==action.payload)
            }

            tShaxesRemove.map((s: any) => {
                let s_Columns: any = [];
                let s_Schema: any = [];
                if (s?.schema) {
                    let cleanedSchema = cleanJSONString(s?.schema);
                    s_Schema = cleanedSchema && JSON.parse(cleanedSchema);
                }

                s_Columns = s_Schema?.map((x: any) => {
                    return { name: x.name, type: x.type }
                })                               
            })
            
            return {
                ...state,
                shaxesList: tShaxesRemove,
                edgeList:tEdgeList,                                         
                isChangeSelectedColumns: !s_isChangeSelectedColumnsRemove
            };

        case DataModelDesignerActionTypes.CHANGE_TABALE_POSITION:
           
            var s_tShaxes = state.shaxesList;
        
            const dts = s_tShaxes.findIndex((x: any) => x.uniqueId === action.payload.id)
            if (dts !== -1) {

                s_tShaxes[dts].position = action.payload.position
            }          
            
            return {
                ...state,
                shaxesList: s_tShaxes,                            
            };

        case DataModelDesignerActionTypes.CHANGE_NEWFIELD:
            const aNewFields = action.payload
            let taFieldList = [...state.fieldList, ...aNewFields]
            return {
                ...state,
                newFieldList: aNewFields,
                fieldList: taFieldList,
                allFieldList: taFieldList
            };

        case DataModelDesignerActionTypes.CHANGE_ADDNEWFIELD:
            const addedNewField = action.payload

            let tNewFields = [...state.newFieldList, addedNewField]
            let tFieldList = [...state.fieldList, addedNewField]

            return {
                ...state,
                newFieldList: tNewFields,
                fieldList: tFieldList,
                allFieldList: tFieldList
            };

        case DataModelDesignerActionTypes.CHANGE_DATAMODELID:
            return {
                ...state,
                dataModelId: action.payload,
            };

        case DataModelDesignerActionTypes.CHANGE_EDGES:
            return {
                ...state,
                edgeList: action.payload,
            };

        default:
            return state;
    }
};

export default DataModelDesign;
